<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('semesterdate')"
                        :isNewButton="true"
                        :isColumns="true"
                        @new-button-click="createForm"
                        @filter-div-status="datatable.filterStatus = $event"
                >
                    <template v-slot:columns>
                        <div class="mb-1"
                             v-for="(column, key) in datatable.columns"
                             v-bind:key="key">
                            <b-form-checkbox v-model="column.hidden"
                                             :id="'checkbox-' + key"
                                             :name="'checkbox-' + key"
                                             :value="false"
                                             :unchecked-value="true"
                                             v-if="column.field != 'buttons'">
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('semesterdate')"
                              :isNewButton="true"
                              :isColumns="true"
                              @new-button-click="createForm"
                              @filter-div-status="datatable.filterStatus = $event"
                >
                    <template v-slot:columns>
                        <div class="mb-1"
                             v-for="(column, key) in datatable.columns"
                             v-bind:key="key">
                            <b-form-checkbox v-model="column.hidden"
                                             :id="'checkbox-' + key"
                                             :name="'checkbox-' + key"
                                             :value="false"
                                             :unchecked-value="true"
                                             v-if="column.field != 'buttons'">
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </HeaderMobile>
            </template>
            <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear">
                <b-row>
                    <b-col sm="12" md="6" lg="3">
                        <b-form-group :label="$t('period')">
                            <semesters-selectbox v-model="datatable.queryParams.filter.semester_id">
                            </semesters-selectbox>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
                       :total="datatable.total" :queryParams="datatable.queryParams" :lineNumbers="false"
                       @on-page-change="onPageChange" @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable">
            </datatable>
            <CommonModal ref="modal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    <div>{{ process_title == 'create' ? $t("add") : '' }}</div>
                    <div>{{ process_title == 'edit' ? $t("edit") : '' }}</div>
                    <div>{{ process_title == 'show' ? $t("show") : '' }}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <create v-if="process_title==='create'" @success="successProcess"/>
                    <update v-if="process_title==='edit'" :id="id" @success="successProcess"/>
                    <show v-if="process_title==='show'" :id="id"/>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile.vue";
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";

import SemestersSelectbox from "@/components/interactive-fields/SemestersSelectbox.vue";

import CommonModal from "@/components/elements/CommonModal";

import SemesterDateService from "@/services/SemesterDateService";

import Create from "./Create.vue";
import Update from "./Update.vue"
import Show from "./Show.vue"


import qs from "qs";


export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        DatatableFilter,
        Datatable,

        Create,
        Update,
        Show,

        CommonModal,

        SemestersSelectbox,

    },
    metaInfo() {
        return {
            title: this.$t("semesterdate"),
        };
    },
    data() {
        return {
            id: null,
            process_title: null,
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: "",
                        field: "buttons",
                        html: true,
                        sortable: false,
                        tdClass: "p-0 text-center w-40 align-middle",
                        buttons: [
                            {
                                text: this.$t("edit"),
                                class: "ri-edit-box-line",
                                callback: ({id}) => {
                                    this.id = id
                                    this.updateForm();
                                },
                            },
                            {
                                text: this.$t("show"),
                                class: "ri-eye-line",
                                callback: ({id}) => {
                                    this.id = id
                                    this.showForm();
                                },
                            },
                            {
                                text: this.$t("delete"),
                                class: "ri-delete-bin-2-line",
                                callback: ({id}) => {
                                    this.del(id);
                                },
                            },
                        ],
                    },
                    {
                        label: this.$t("academic_year"),
                        field: "academic_year",
                        hidden: false,
                        sortable: false,
                    },
                    {
                        label: this.$t("semester"),
                        field: "semester",
                        hidden: false,
                        sortable: false,
                    },
                    {
                        label: this.$t("type"),
                        field: this.getLocaleField("type"),
                        hidden: false,
                        sortable: true,
                    },
                    {
                        label: this.$t("name"),
                        field: this.$i18n.locale === 'en' ? "type_name_en" : "type_name",
                        hidden: false,
                        sortable: false,
                    },
                    {
                        label: this.$t("start_date"),
                        field: "start_date",
                        hidden: false,
                        sortable: false,
                    },
                    {
                        label: this.$t("end_date"),
                        field: "end_date",
                        hidden: false,
                        sortable: false,
                    },
                    {
                        label: this.$t("class"),
                        field: this.getLocaleField("class_names"),
                        hidden: false,
                        sortable: false,
                        formatFn: (value) => value ? value.join(", ") : ""
                    },
                    {
                        label: this.$t("level"),
                        field: this.getLocaleField("level_names"),
                        hidden: false,
                        sortable: false,
                        formatFn: (value) => value ? value.join(", ") : ""
                    },
                    {
                        label: this.$t("faculty"),
                        field: this.getLocaleField("faculty_names"),
                        hidden: false,
                        sortable: false,
                        formatFn: (value) => value ? value.join(", ") : ""
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: "id",
                    page: 1,
                    limit: 20,
                },
            },
        };
    },
    methods: {
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        filterClear() {
            this.datatable.queryParams.filter = {};
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onSortChange(params) {
            const sortType = params[0].type == "desc" ? "-" : "";
            this.datatable.queryParams.sort = sortType + params[0].field;
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    ...this.datatable.queryParams,
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false}),
            };

            return SemesterDateService.getAll(config)
                .then((response) => {
                    this.datatable.rows = response.data.data;
                    this.datatable.total = response.data.pagination.total;
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        showForm() {
            this.process_title = 'show'
            this.showModal()
        },
        updateForm() {
            this.process_title = 'edit'
            this.showModal()
        },
        createForm() {
            this.process_title = 'create'
            this.showModal()
        },
        del(id) {
            this.$swal.fire({
                text: this.$t('are_you_sure_to_delete'),
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no'),
            }).then((result) => {
                if (result.isConfirmed) {
                    SemesterDateService.deleteSemesterDate(id)
                        .then((response) => {
                            this.filter();
                            this.$toast.success(this.$t("api." + response.data.message));
                        })
                        .catch(err => {
                            this.showErrors(err)
                        });
                }
            })
        },
        showModal() {
            this.$refs.modal.$refs.commonModal.show();
        },
        hideModal() {
            this.$refs.modal.$refs.commonModal.hide();
        },
        successProcess() {
            this.process_title = null;
            this.getRows();
            this.hideModal();
        },
        formClear() {
            this.process_title = null;
            this.hideModal()
        }
    },
};
</script>

